// app
import difference from 'lodash/difference';
import { generic } from 'utils';
import { articleSchema } from './schemas.yup';

const formatArticle = (article) => {
  const { id, heading, organisation_logo_url, excerpt, featured_image_url, external_url, date, topics } = article;
  return { id, heading, organisation_logo_url, excerpt, featured_image_url, external_url, date, topics };
};

const utilsSchemas = {
  parseArticles: (articles) => {
    return articles.filter((article) => articleSchema.isValidSync(article)).map((article) => formatArticle(article));
  },

  removeIcons: (fields) => {
    if (generic.isInvalidOrEmptyArray(fields)) return [];

    return fields.map((field) => {
      const fieldCopy = { ...field };
      delete fieldCopy.icon;

      return fieldCopy;
    });
  },
  checkDependencies: (dependencies, options) => difference(dependencies, Object.keys(options)).length === 0,
};

export default utilsSchemas;
